import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"
import ColorPage from "./views/Color.vue"
import ColorCanvasPage from "./views/ColorCanvas.vue"
import CameraPage from "./views/Camera.vue"
import TagPage from "./views/Tag.vue"

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/color",
            name: "ColorPage",
            component: ColorPage
        },
        {
            path: "/color-canvas",
            name: "ColorCanvasPage",
            component: ColorCanvasPage
        },
        {
            path: "/camera",
            name: "CameraPage",
            component: CameraPage
        },
        {
            path: "/tag",
            name: "TagPage",
            component: TagPage
        }
    ]
})
